module.exports = __webpack_public_path__ + "static/media/sample-map.577ce5ab.png";